/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PublicRebateCodeEntity = {
    id: string;
    organizationId: string;
    name: string;
    type: PublicRebateCodeEntity.type;
    valueInMills: number;
    scope: PublicRebateCodeEntity.scope;
    minimumSpendingInMills: number | null;
    maxUsages: number | null;
    maxUsagesPerCustomer: number | null;
    validFrom: string;
    validUntil: string | null;
    registeredUsersOnly: boolean;
    verifiedPhoneRequired: boolean;
    customerNote: string | null;
    canBeCombined: boolean;
    organizationEligibility: boolean;
};
export namespace PublicRebateCodeEntity {
    export enum type {
        ABSOLUTE = 'ABSOLUTE',
        PERMILLAGE = 'PERMILLAGE',
    }
    export enum scope {
        ORDER = 'ORDER',
        BOOKING = 'BOOKING',
        CHEAPEST_BOOKING = 'CHEAPEST_BOOKING',
        DUPLICATE_BOOKABLE = 'DUPLICATE_BOOKABLE',
    }
}

